import { Link ,Typography} from '@mui/material';

export default function Copyright(props: any) {
  return (
    <Typography variant="body2" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" target="_blank" rel="noopener noreferrer" href="https://www.cubic.com/transportation">
        Cubic Transportation Systems.
      </Link>{' '}
      {' All Rights Reserved.'}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}